// action types
export const modal = {
    INITIALIZE: 'modal/INITIALIZE',
    SHOW_MODAL: 'modal/SHOW_MODAL',
    SHOW_MESSAGE: 'modal/SHOW_MESSAGE',
    SHOW_MODAL_EX: 'modal/SHOW_MODAL_EX',
    SHOW_MODAL_UPLOAD_FILE: 'modal/SHOW_MODAL_UPLOAD_FILE',
    SHOW_START: 'modal/SHOW_START',
};
export const menu = {
    INITIALIZE: 'menu/INITIALIZE',
    SHOW_MENU: 'menu/SHOW_MENU',
};

// action creators
export const modalActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: modal.INITIALIZE });
    },
    showModal: (show) => (dispatch) => {
        dispatch({ type: modal.SHOW_MODAL, payload: show });
    },
    showMessage: (show) => (dispatch) => {
        dispatch({ type: modal.SHOW_MESSAGE, payload: show });
    },
    showModalEx:
        ({ mode, item, peer }) =>
        (dispatch) => {
            dispatch({ type: modal.SHOW_MODAL_EX, payload: { mode, item, peer } });
        },
    showModalUpLoadFile: (open) => (dispatch) => {
        dispatch({ type: modal.SHOW_MODAL_UPLOAD_FILE, payload: open });
    },
    showStart: (status) => (dispatch) => {
        dispatch({ type: modal.SHOW_START, payload: status });
    },
};
export const menuActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: menu.INITIALIZE });
    },
    showMenu: (open) => (dispatch) => {
        dispatch({ type: menu.SHOW_MENU, payload: open });
    },
};
